import styled, { css } from 'styled-components';

const Headline = styled.h1`
   display: block;
   font-weight: 700;
   line-height: 1.3;
   margin: 0;

   ${({ size }) =>
      size === 'XXL' &&
      css`
         font-size: 32px;
      `}

   ${({ size }) =>
      size === 'XL' &&
      css`
         font-size: 28px;
      `}

    ${({ size }) =>
      size === 'L' &&
      css`
         font-size: 24px;
      `}

    ${({ size }) =>
      size === 'M' &&
      css`
         font-size: 22px;
      `}


  ${({ size }) =>
      size === 'S' &&
      css`
         font-size: 18px;
      `}
`;

export default Headline;
